import { prependArt, verifyProduct } from 'redux-store/products/products.utils';
import type { IShoppingProductsMap } from 'utils/constants';
import { nonNullable } from 'utils/nonNullable';

import { DoorHeightEnum } from 'CoreAPI/Components/DoorHeightEnum';
import { DoorWidthEnum } from 'CoreAPI/Components/DoorWidthEnum';

export const DEFAULT_PANEL_STYLE_INDEX = [6, 10]; // MEHAMN dark grey and MEHAMN white oak, goes by order as priority.

export const PANELS_THAT_CAN_NOT_BE_CUT = [0, 1, 2, 3, 13, 15, 17]; // AULI x 2, BJÖRNÖYA, FÄRVIK, SEKKEN, SVARTISDAL & TJÖRHOM
const PANELS_THAT_CAN_BE_FLIPPED = [6, 7, 8, 9, 10, 11, 12, 16]; // MEHAMN, TJODALYNG

const ALL_PANELS = [
  [
    // wide
    [
      // low
      '10211276', //	AULI 4 pnls f sldng dr frm 100x201 mirror glass
      '00587741', //  AULI NEW 2024 4 pnls f sldng dr frm 100x201 mirror glass
      '10480749', //	BJÖRNÖYA 4 pnls f sd fr 100x201 gry tint eff
      '20250314', //	FÄRVIK 4 pnls f sldng dr frm 100x201 white glass
      '00373801', //	HOKKSUND 4 pnls f sldng dr frm 100x201 hi-gl lbeig
      '60382341', //	HOKKSUND 4 pnls f sldng dr frm 100x201 hi-gl lgrey
      '80510903', //  MEHAMN 4 pnls f sldng dr frm 100x201 dgrey/bei
      '30575572', //  MEHAMN 4 pnls f sldng dr frm 100x201 lblue/lgrn
      '20421189', //	MEHAMN 4 pnls f sd frm 100x201 bbsa eff/bsa eff
      '00445252', //	MEHAMN 4 pnls f sldng dr frm 100x201 oak eff/lgrey
      '00421185', //	MEHAMN 4 pnls f sldng dr frm 100x201 wso eff/wh,
      '80605760', // MEHAMN 4 panels for sliding door frame, walnut effect/blue, 100x201 cm (39 3/8x79 1/8 ")
      '00605759', // MEHAMN 4 ps sg dr fm 100x201 dbrn oak eff/oak eff
      '20442342', //	SEKKEN N 4 pnls f sldng dr frm 100x201 frst gls, Not available in app config
      '20483177', //	STORFOSNA 4 pnls f sldng dr frm 100x201 lgrey felt, Not available in app config
      '20473569', //  SVARTISDAL 100x201 cm
      '10481070', //	TJODALYNG 4 pnls f sldng dr frm 100x201 lgr/dbl, Not available in app config
      '20480678' // TJÖRHOM 4 pnls f sldng dr frm 100x201 white
    ],
    [
      // high
      '90211277', //	AULI 4 pnls f sldng dr frm 100x236 mirror glass
      '60587743', //  AULI NEW 2024 4 pnls f sldng dr frm 100x236 mirror glass
      '70480751', //	BJÖRNÖYA 4 pnls f sd dr fr 100x236 gry tint eff
      '70250316', //	FÄRVIK 4 pnls f sldng dr frm 100x236 white glass
      '80373802', //	HOKKSUND 4 pnls f sldng dr frm 100x236 hi-gl lbeig
      '00382344', //	HOKKSUND 4 pnls f sldng dr frm 100x236 hi-gl lgrey
      '30510905', //  MEHAMN 4 pnls f sldng dr frm 100x236 dgrey/bei
      '90575574', //  MEHAMN 4 pnls f sldng dr frm 100x236 lblue/lgrn
      '00421190', //	MEHAMN 4 pnls f sd frm 100x236 bbsa eff/bsa eff, Not available in app config
      '80445253', //	MEHAMN 4 pnls f sldng dr frm 100x236 oak eff/lgrey, Not available in app config
      '80421186', //	MEHAMN 4 pnls f sldng dr frm 100x236 wso eff/wh
      '60605761', // MEHAMN 4 panels for sliding door frame, walnut effect/blue, 100x236 cm (39 3/8x92 7/8 ")
      '40605762', // MEHAMN 4 ps sg dr fm 100x236 dbrn oak eff/oak eff
      '50442345', //	SEKKEN N 4 pnls f sldng dr frm 100x236 frst gls, Not available in app config
      '80483179', //	STORFOSNA 4 pnls f sldng dr frm 100x236 lgrey felt, Not available in app config
      '60473572', //  SVARTISDAL 100x236 cm
      '70481072', //	TJODALYNG 4 pnls f sldng dr frm 100x236 lg/dbl, Not available in app config
      '60480681' //   TJÖRHOM 4 pnls f sldng dr frm 100x236 white
    ]
  ],
  [
    // thin
    [
      // low
      '60211274', //	AULI 4 pnls f sldng dr frm 75x201 mirror glass
      '10587745', //  AULI NEW 2024 4 pnls f sldng dr frm 75x201 mirror glass
      '10480754', //	BJÖRNÖYA 4 pnls f sd dr fr 75x201 gry tint eff
      '60250312', //	FÄRVIK 4 pnls f sldng dr frm 75x201 white glass
      '60373803', //	HOKKSUND 4 pnls f sldng dr frm 75x201 hi-gl lbeige
      '30382347', //	HOKKSUND 4 pnls f sldng dr frm 75x201 hi-gl lgrey
      '70510908', //  MEHAMN 4 pnls f sldng dr frm 75x201 dgrey/bei
      '90575569', //  MEHAMN 4 pnls f sldng dr frm 75x201 lblue/lgrn
      '80421191', //	MEHAMN 4 pnls f sd frm 75x201 bbsa eff/bsa eff, Not available in app config
      '60445254', //	MEHAMN 4 pnls f sldng dr frm 75x201 oak eff/lgrey, Not available in app config
      '90421195', //	MEHAMN 4 pnls f sldng dr frm 75x201 wso eff/wh
      '70605746', // MEHAMN 4 panels for sliding door frame, walnut effect/blue, 75x201 cm (29 1/2x79 1/8 ")
      '50605747', // MEHAMN 4 pnls f sldr frm 75x201 dbrn oak eff/oak
      '90442348', //	SEKKEN N 4 pnls f sldng dr frm 75x201 frst gls, Not available in app config
      '40483181', //	STORFOSNA 4 pnls f sldng dr frm 75x201 lgrey felt, Not available in app config
      '90473575', //  SVARTISDAL 75x201 cm
      '30481074', //	TJODALYNG 4 pnls f sldng dr frm 75x201 lgrn/dbl, Not available in app config
      '20480683' //	TJÖRHOM 4 pnls f sldng dr frm 75x201 white
    ],
    [
      // high
      '30211275', //	AULI 4 pnls f sldng dr frm 75x236 mirror glass
      '70587747', //  AULI NEW 2024 4 pnls f sldng dr frm 75x236 mirror glass
      '60480756', //	BJÖRNÖYA 4 pnls f sd fr 75x236 gry tint eff
      '20250333', //	FÄRVIK 4 pnls f sldng dr frm 75x236 white glass
      '40373804', //	HOKKSUND 4 pnls f sldng dr frm 75x236 hi-gl lbeige
      '70382350', //	HOKKSUND 4 pnls f sldng dr frm 75x236 hi-gl lgrey
      '30510910', //  MEHAMN 4 pnls f sldng dr frm 75x236 dgrey/beige
      '50575571', //  MEHAMN 4 pnls f sldng dr frm 75x236 lblue/lgrn
      '60421192', //	MEHAMN 4 pnls f sd frm 75x236 bbsa eff/bsa eff, Not available in app config
      '30445255', //	MEHAMN 4 pnls f sldng dr frm 75x236 oak eff/lgrey, Not available in app config
      '40421188', //	MEHAMN 4 pnls f sldng dr frm 75x236 wso eff/wh
      '70605751', // MEHAMN 4 panels for sliding door frame, walnut effect/blue, 75x236 cm (29 1/2x92 7/8 ")
      '50605752', //  MEHAMN 4 ps f sl dr fm 75x236 dbrn oak eff/oak eff
      '10442352', //	SEKKEN N 4 pnls f sldng dr frm 75x236 frst gls, Not available in app config
      '00483183', //	STORFOSNA 4 pnls f sldng dr frm 75x236 lgrey felt, Not available in app config
      '30473578', //  SVARTISDAL 75x236 cm
      '80481076', //	TJODALYNG 4 pnls f sldng dr frm 75x236 lgrn/dbl, Not available in app config
      '70480685' //  TJÖRHOM 4 pnls f sldng dr frm 75x236 white
    ]
  ]
];

export const getDefaultPanels = (doorHeightOptionsAvailable: DoorHeightEnum[]) => {
  const doorHeight = doorHeightOptionsAvailable.includes(DoorHeightEnum.High) ? DoorHeightEnum.High : DoorHeightEnum.Low;

  return ALL_PANELS[DoorWidthEnum.Wide][doorHeight];
};

const ALL_PANELS_FLATTENED = ALL_PANELS.flat(2);

export const getPanelProductReference = (styleIndex: number, width: DoorWidthEnum, height: DoorHeightEnum) => {
  return ALL_PANELS[width][height][styleIndex];
};

export const getPanelProductReferences = (width: DoorWidthEnum, height: DoorHeightEnum) => {
  return ALL_PANELS[width][height];
};

export const isPanelPossibleToCut = (index: number) => {
  return !PANELS_THAT_CAN_NOT_BE_CUT.includes(index);
};

export const isPanelPossibleToFlip = (index: number) => {
  return PANELS_THAT_CAN_BE_FLIPPED.includes(index);
};

export const getPanelStyleIndex = (panelArticleId: string) => {
  return (
    ALL_PANELS_FLATTENED.findIndex((id) => {
      return id === panelArticleId;
    }) % ALL_PANELS[0][0].length
  );
};

/**
 *  Gets first panel in this order:
 *  1. Get global fallback if valid.
 *  2. Get first panel in list that is valid.
 *
 */
export const getDefaultPanel = (productData: IShoppingProductsMap, defaultPanels: string[]) => {
  const globalDefaultPanels = DEFAULT_PANEL_STYLE_INDEX.map((value) => {
    const articleId = prependArt(defaultPanels[value]);
    const globalDefaultPanelData = verifyProduct(productData[articleId], defaultPanels) ? productData[articleId] : undefined;
    return globalDefaultPanelData;
  }).filter(nonNullable);

  if (globalDefaultPanels.length > 0) {
    return globalDefaultPanels[0];
  }

  const validPanels = defaultPanels.filter((value) => {
    return verifyProduct(productData[prependArt(value)], defaultPanels);
  });

  return productData[prependArt(validPanels[0])];
};
